<template>
  <label
    :class="[
        `form__cb-group formulate-input-element formulate-input-element--${context.type}`,
        { 'formulate-input-element--selected' : selected }
    ]"
    :data-type="context.type"
  >
    <!--
      This explicit break out of types is due to a Vue bug that causes IE11 to
      not when using v-model + dynamic :type + :value (thanks @Christoph-Wagner)
      https://github.com/vuejs/vue/issues/8379
    -->
    <input
      v-if="type === 'radio'"
      v-model="context.model"
      type="radio"
      :value="context.options[0].value"
      v-bind="attributes"
      @blur="context.blurHandler"
    >
    <input
      v-else
      v-model="context.model"
      type="checkbox"
      :value="context.options[0].value"
      v-bind="attributes"
      @blur="context.blurHandler"
    >
    <!--
      Ok, so for reasons that we cannot explain, the <label> here will not
      update when the attribute.id changes. Possible bug in core? Either way,
      making this a <component> forces vue to re-render this label when the
      id changes.

      https://github.com/wearebraid/vue-formulate/issues/75
    -->
    <!-- <component
      :is="`label`"
      class="formulate-input-element-decorator"
      :for="attributes.id"
    /> -->
    <span :class="['form__cb-box', { 'form__cb-box--selected' : selected }]"><SVGicon-tick /></span>
    <span :class="['form__cb-label', { 'sr-only' : srOnly }, { 'form__cb-label--selected' : selected }]">
        {{ context.options[0].label }}
    </span>
  </label>
</template>

<script>

export default {
  name: 'FormulateInputBox',
  props: {
    context: {
      type: Object,
      required: true
    },
    srOnly: {
        type: Boolean,
        default: false
    }
  },
  computed: {
    model () {
      return this.context.model
    },
    type () {
      return this.context.type
    },
    id () {
      return this.context.id
    },
    attributes () {
      return this.context.attributes || {}
    },
    hasValue () {
      return !!this.context.model
    },
    selected () {
        if (Array.isArray(this.context.model)) {
          const hasValue = this.context.model.filter(val => val.includes(this.context.options[0].value))
          return hasValue.length > 0
        } else return this.context.model
    }
  }
}
</script>
